import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { Placeholder } from "@/pages/Placeholder";
import { adminRoutes } from "./admin-routes";
import { centralRoutes } from "./central-routes";
import { RequireAuth, wrap } from "./guards";

const Login = lazy(() =>
  import("@/pages/auth/Login").then((m) => ({ default: m.Login })),
);
const TestPage = lazy(() =>
  import("@/pages/TestPage").then((m) => ({ default: m.TestPage })),
);

export const router = createBrowserRouter([
  { path: "/test", element: wrap(<TestPage />) },
  { path: "/login", element: wrap(<Login portal="central" />) },
  { path: "/admin/login", element: wrap(<Login portal="admin" />) },
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      ...centralRoutes,
      ...adminRoutes,
      { path: "*", element: <Placeholder /> },
    ],
  },
]);
